import { Card, Typography, useMediaQuery, useTheme } from "@mui/material";
import timeout from "../assets/timeout.png";
function Timeout(): JSX.Element {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="Animation fullViewPort displayCenter">
      <Card
        style={{
          padding: "5%",
          width: isSmallScreen ? "80%" : "40%",
          borderRadius: "10%",
          textAlign: "center",
        }}
      >
        <div>
          <img alt="session timeout" src={timeout} height={200} />
        </div>

        <Typography mb={2} variant={isSmallScreen ? "h3" : "h4"}>
          Session Expired
        </Typography>
        <Typography variant="body1">
          Please Scan the QR Code in the EGM again, to get the License Code.
        </Typography>
      </Card>
    </div>
  );
}

export default Timeout;
